export const SET_DEVICE_ID = "SET_DEVICE_ID"